const SYNONYM_DISTRACTOR_WORD_TYPE_IDS = {
  noun: 'd5c5fcef-bb92-48a8-b00b-e7c71cb33068',
  verb: '4c4389c1-f805-4d1c-ba45-6721cf400aef',
  adjective: '17ac1392-e5f4-4651-9831-2d1fc7bba280',
  adverb: 'ad1caf92-c167-42fc-85c7-797050ab628d',
  number: '1a0d84ff-a903-4be9-b0a8-22fdcc211506',
};

const SYNONYM_DISTRACTOR_WORDS_BY_LANGUAGE_AND_WORD_TYPE = {
  "DE": {
    "noun": [
      "Rückgriff",
      "Hündin",
      "Postleitzahl",
      "Verlobung",
      "Matheunterricht",
      "Ansage",
      "Renaissance",
      "Priesterweihe",
      "Auswirkung",
      "Hemd",
      "Verfasserin",
      "Perle",
      "Elan",
      "V-Ausschnitt",
      "Diskussion",
      "Vorkehrung",
      "Raureif",
      "Briefverkehr",
      "Notfall",
      "Wertstoff",
      "Beckenbodengymnastik",
      "Eizelle",
      "Bierwurst",
      "Grenzkontrolle",
      "Zeugnis",
      "Braut",
      "Kinderarbeit",
      "Jahrtausend",
      "Betriebsbesichtigung",
      "Angststörung",
      "Wanderurlaub",
      "Jugendliche",
      "Verlässlichkeit",
      "Engländer",
      "Bearbeitungszeit",
      "Atem",
      "Halsband",
      "Ast",
      "Botanik",
      "Steuer",
      "Werkzeug",
      "Bahnhof",
      "Nachmittag",
      "Gemälde",
      "Gedanke",
      "Schlüssel",
      "Feiertag",
      "Kreuzung",
      "Geräusch",
      "Abenteuer"
    ],
    "verb": [
      "skizzieren",
      "verdunsten",
      "evakuieren",
      "rumliegen",
      "importieren",
      "tunken",
      "reingreifen",
      "mitschleppen",
      "zusammenmixen",
      "wedeln",
      "breittreten",
      "gedeihen",
      "verwalten",
      "nachahmen",
      "braten",
      "abtrocknen",
      "sich bewegen",
      "ergeben",
      "wegbewegen",
      "terrorisieren",
      "anbetteln",
      "überprüfen",
      "verschwinden",
      "zurückverfolgen",
      "nachzahlen",
      "zurückfinden",
      "warnen",
      "tagträumen",
      "leichtfallen",
      "horchen",
      "ruinieren",
      "aufessen",
      "nicht gebacken kriegen",
      "hinsetzen",
      "verreisen",
      "sich sträuben",
      "herausfiltern",
      "mitverfolgen",
      "beweisen",
      "filtrieren",
      "umziehen",
      "schütteln",
      "vergleichen",
      "ankündigen",
      "ausweichen",
      "übernachten",
      "verzichten",
      "einpacken",
      "auftauchen",
      "überreden"
    ],
    "adjective": [
      "integer",
      "unaufgefordert",
      "deprimierend",
      "querfeldein",
      "abgeglichen",
      "fortgeschritten",
      "traurig",
      "grob fahrlässig",
      "unverdrossen",
      "knauserig",
      "vorbereitet",
      "ungreifbar",
      "tapfer",
      "episch",
      "rückwirkend",
      "verstärkend",
      "gescheit",
      "hochbetagt",
      "haltbar",
      "angetrunken",
      "fortschrittlich",
      "schriftlich",
      "vollkommen",
      "zeitnah",
      "geisteskrank",
      "bewusst",
      "japanisch",
      "zerrissen",
      "tagelang",
      "struppig",
      "kulturell",
      "gesundheitsbewusst",
      "begründet",
      "beigefügt",
      "gläubig",
      "berüchtigt",
      "verlockt",
      "unzensiert",
      "hungrig",
      "allmählich",
      "vorsichtig",
      "einzigartig",
      "neugierig",
      "kostbar",
      "freundlich",
      "unsicher",
      "gewaltig",
      "mühelos",
      "auffällig",
      "nützlich"
    ],
    "adverb": [
      "unvorsichtigerweise",
      "einfach",
      "ferner",
      "drumherum",
      "klar",
      "erstaunlicherweise",
      "fairerweise",
      "vorwiegend",
      "circa",
      "im Voraus",
      "stilecht",
      "verneint",
      "ungeschickt",
      "beispielsweise",
      "geradeaus",
      "übereinander",
      "zufälligerweise",
      "wodurch",
      "füreinander",
      "montagnachmittags",
      "zu Fuß",
      "geschickt",
      "übrigens",
      "anscheinend",
      "demzufolge",
      "lieber",
      "überhaupt",
      "ausdrücklich",
      "genauso",
      "gesondert",
      "darüber",
      "daheim",
      "bewiesenermaßen",
      "vornehmlich",
      "gleich",
      "nachweislich",
      "durch",
      "hinterher",
      "maximal",
      "morgen",
      "gelegentlich",
      "heimlich",
      "beinahe",
      "unterwegs",
      "sogleich",
      "mittlerweile",
      "vergeblich",
      "ausnahmsweise",
      "rückwärts",
      "jederzeit"
    ],
    "number": [
      "dritte",
      "neunundneunzig",
      "zweiundvierzig",
      "elf",
      "einundvierzig",
      "dreihundert",
      "fünfundneunzig",
      "sechsundsiebzig",
      "einhundertacht",
      "zweitausendneunzehn",
      "eintausend",
      "fünftausend",
      "zweiunddreißig",
      "fünfundachtzig",
      "dreihundertfünfzig",
      "sechzehn",
      "eineinhalbfach",
      "neunzehn",
      "achtzig",
      "hundert",
      "siebzig",
      "siebenundzwanzig",
      "Zweitausendzehn",
      "vierundneunzig",
      "einundfünfzig",
      "zehntausendneunundvierzig",
      "zwei",
      "achthundert",
      "zwölf",
      "sechsundsechzig",
      "zweihundertsiebzig",
      "zweitausenddreizehn",
      "dreitausendfünfzig",
      "zweitausendsechzehn",
      "sechsundachtzig",
      "dreiundfünfzig",
      "fünfzehntausend",
      "fünfhundert",
      "fünfundsiebzig",
      "tausend",
      "vierzehn",
      "achtundzwanzig",
      "sechsunddreißig",
      "neunundvierzig",
      "siebenhundert",
      "zweitausend",
      "dreizehnte",
      "einundzwanzig",
      "vierhundertzwanzig",
      "neunzig"
    ]
  },
  "ES": {
    "noun": [
      "hámster",
      "camisón",
      "sol",
      "vehículo",
      "tacón",
      "estudio",
      "portavoz",
      "alemán",
      "moda",
      "labor",
      "periodo",
      "misa",
      "foto",
      "educación",
      "extraterrestre",
      "tesis",
      "naturaleza",
      "hueso",
      "palacio",
      "comunicado",
      "célula",
      "ensayo",
      "invitado",
      "motivo",
      "gasolina",
      "capacidad",
      "síndrome",
      "bar",
      "compañero",
      "mano de obra",
      "gaseosa",
      "cabello",
      "policía",
      "boda",
      "móvil",
      "pobreza",
      "casualidad",
      "millón",
      "colombiano",
      "distrito",
      "escalera",
      "archivo",
      "tormenta",
      "vecindario",
      "almuerzo",
      "pantalla",
      "recuerdo",
      "mercado",
      "frontera",
      "herramienta"
    ],
    "verb": [
      "exportar",
      "vigilar",
      "firmar",
      "solicitar",
      "divertirse",
      "afirmar",
      "atar",
      "iluminar",
      "diseñar",
      "apasionar",
      "fumar",
      "poder",
      "quemarse",
      "pelearse",
      "extender",
      "oponer",
      "gritar",
      "organizar",
      "derrotar",
      "renovar",
      "lastimar",
      "secarse",
      "depende",
      "llover",
      "decidir",
      "contar",
      "fabricar",
      "soportar",
      "marcar",
      "rendirse",
      "posponer",
      "crecer",
      "insistir",
      "desinfectar",
      "involucrarse",
      "completar",
      "sufrir",
      "cortar",
      "desayunar",
      "acostumbrar",
      "aplaudir",
      "aparecer",
      "traducir",
      "proteger",
      "descubrir",
      "mezclar",
      "ahorrar",
      "saludar",
      "esconder",
      "repetir"
    ],
    "adjective": [
      "original",
      "dinámico",
      "único",
      "ideal",
      "autonómico",
      "inmenso",
      "claro",
      "mejor",
      "formal",
      "involucrado",
      "absurdo",
      "pagado",
      "rock",
      "divino",
      "estable",
      "parecido",
      "informado",
      "cotidiano",
      "sorpresa",
      "cubano",
      "vacío",
      "último",
      "salado",
      "afortunado",
      "empresarial",
      "agudo",
      "dedicado",
      "asustado",
      "blanco",
      "sentado",
      "ilegal",
      "policial",
      "marrón",
      "propio",
      "posible",
      "ligero",
      "puntual",
      "educativo",
      "tormentoso",
      "mismo",
      "brillante",
      "silencioso",
      "profundo",
      "tranquilo",
      "valiente",
      "moderno",
      "lejano",
      "curioso",
      "estrecho",
      "amable"
    ],
    "adverb": [
      "asimismo",
      "afuera",
      "muchísimo",
      "casi",
      "previamente",
      "generalmente",
      "apenas",
      "curiosamente",
      "directamente",
      "bien",
      "siempre",
      "tan",
      "probablemente",
      "de repente",
      "tarde",
      "seguro",
      "finalmente",
      "incluso",
      "lejos",
      "pacientemente",
      "enseguida",
      "al lado",
      "mañana",
      "demasiado",
      "absolutamente",
      "aparte",
      "solo",
      "escasamente",
      "posiblemente",
      "personalmente",
      "cuánto",
      "tanto",
      "detrás",
      "claro",
      "nunca",
      "antes",
      "aproximadamente",
      "cerca",
      "por ejemplo",
      "totalmente",
      "lentamente",
      "quizás",
      "adentro",
      "pronto",
      "todavía",
      "raramente",
      "juntos",
      "arriba",
      "después",
      "gratis"
    ],
    "number": [
      "trece",
      "veintidós",
      "veinte",
      "setenta y nueve",
      "ochenta y cinco",
      "noventa y seis",
      "sesenta y cuatro",
      "cien",
      "setenta y seis",
      "cincuenta",
      "veintinueve",
      "setenta",
      "veintiseis",
      "sexto",
      "treinta y cuatro",
      "noventa",
      "veinticuatro",
      "ochenta",
      "dieciocho",
      "trescientos",
      "catorce",
      "diez",
      "cincuenta y uno",
      "doscientos",
      "noventa y ocho",
      "dieciséis",
      "treinta y siete",
      "octavo",
      "tercer",
      "setenta y uno",
      "cuatro",
      "sesenta y dos",
      "cuarenta",
      "veintisiete",
      "cuarenta y seis",
      "sesenta y nueve",
      "seis",
      "segundo",
      "treinta y uno",
      "veintitrés",
      "quince",
      "cincuenta y ocho",
      "ochenta y dos",
      "novecientos",
      "mil",
      "tercero",
      "treinta",
      "setenta y siete",
      "ciento veinte",
      "cinco mil"
    ]
  },
  "FR": {
    "noun": [
      "tomate",
      "semelle",
      "escalier",
      "cane",
      "scandale",
      "tambour",
      "vague",
      "cheffe",
      "contact",
      "position",
      "lit",
      "emploi",
      "janvier",
      "agneau",
      "flot",
      "chagrin",
      "musicienne",
      "public",
      "disparition",
      "rencontre",
      "Lituanie",
      "toile",
      "parking",
      "tissu",
      "argent",
      "écoute",
      "contribution",
      "peigne",
      "expression",
      "flamme",
      "commande",
      "sirène",
      "victoire",
      "taxi",
      "chambre",
      "dauphin",
      "café",
      "méthode",
      "Amérique du Sud",
      "aveu",
      "bibliothèque",
      "montagne",
      "souvenir",
      "horloge",
      "frontière",
      "village",
      "outil",
      "nuage",
      "courage",
      "voyage"
    ],
    "verb": [
      "surestimer",
      "épeler",
      "insérer",
      "battre",
      "trahir",
      "figer",
      "filer",
      "enfermer",
      "référencer",
      "insulter",
      "allonger",
      "tailler",
      "deviner",
      "se voir",
      "émouvoir",
      "persuader",
      "restreindre",
      "réussir",
      "nouer",
      "impressionner",
      "profiter",
      "dévoiler",
      "hocher",
      "supplier",
      "lister",
      "développer",
      "relater",
      "voiler",
      "envoyer",
      "desservir",
      "spécialiser",
      "imprimer",
      "relever",
      "défendre",
      "prévoir",
      "contribuer",
      "confirmer",
      "reprocher",
      "étaler",
      "calculer",
      "applaudir",
      "choisir",
      "remplacer",
      "découvrir",
      "économiser",
      "mélanger",
      "ranger",
      "saluer",
      "traverser",
      "ralentir"
    ],
    "adjective": [
      "anal",
      "chronique",
      "probable",
      "polonais",
      "quelque",
      "extérieur",
      "russe",
      "fixe",
      "relationnel",
      "théâtral",
      "insuffisant",
      "utile",
      "aveugle",
      "pauvre",
      "divin",
      "extrême",
      "métropolitain",
      "descriptif",
      "révolutionnaire",
      "correct",
      "soucieux",
      "temporel",
      "dix-neuvième",
      "historique",
      "indispensable",
      "vieil",
      "impossible",
      "ne ... aucun",
      "viral",
      "rural",
      "célèbre",
      "gentil",
      "final",
      "chauve",
      "céleste",
      "suffisant",
      "mythique",
      "monothéiste",
      "cruel",
      "objectif",
      "silencieux",
      "brillant",
      "lointain",
      "étroit",
      "paisible",
      "curieux",
      "fragile",
      "moderne",
      "sérieux",
      "rapide"
    ],
    "adverb": [
      "loin",
      "techniquement",
      "dangereusement",
      "hyper",
      "matériellement",
      "près",
      "un peu",
      "évidemment",
      "géographiquement",
      "précieusement",
      "extraordinairement",
      "au-dehors",
      "familièrement",
      "librement",
      "précocement",
      "infiniment",
      "douloureusement",
      "dûment",
      "raisonnablement",
      "chez l'habitant",
      "réciproquement",
      "entrainement",
      "ultérieurement",
      "pratiquement",
      "davantage",
      "environ",
      "sportivement",
      "sûrement",
      "terriblement",
      "impitoyablement",
      "premièrement",
      "idem",
      "perpendiculairement",
      "solidairement",
      "vraiment",
      "récemment",
      "indûment",
      "partout",
      "ci-dessus",
      "séparément",
      "lentement",
      "bientôt",
      "ailleurs",
      "rarement",
      "ensemble",
      "gratuitement",
      "dessus",
      "ensuite",
      "volontiers",
      "parfois"
    ],
    "number": [
      "trente-deux",
      "vingt-six",
      "quarante-huit",
      "quatre-vingt-neuf",
      "sept",
      "quatre-vingt-dix-huit",
      "quatre-vingts",
      "quatre",
      "quarante-sept",
      "quatre-vingt-seize",
      "zéro",
      "cent quatre",
      "quarante-et-un",
      "quatre-vingt-onze",
      "cent cinq",
      "quarante-trois",
      "million",
      "quatre-vingt-treize",
      "cinquante-huit",
      "quatre-vingt-cinq",
      "trente-cinq",
      "vingt-cinq",
      "soixante-et-un",
      "quatre-vingt-dix-neuf",
      "cent",
      "soixante-quinze",
      "soixante-quatorze",
      "milliard",
      "vingt-neuf",
      "quatre cent mille",
      "trente-trois",
      "deux mille treize",
      "soixante-dix-neuf",
      "cinquante-six",
      "soixante-seize",
      "cent trois",
      "cinquante-neuf",
      "soixante-deux",
      "soixante-dix",
      "trois cents",
      "quinze",
      "vingt-huit",
      "trente",
      "soixante-sept",
      "quatre-vingt-deux",
      "neuf cents",
      "mille",
      "troisième",
      "cent vingt",
      "cinq mille"
    ]
  }
};

export { SYNONYM_DISTRACTOR_WORD_TYPE_IDS };

export default SYNONYM_DISTRACTOR_WORDS_BY_LANGUAGE_AND_WORD_TYPE;
